import React, { useEffect } from 'react'

import { useDispatch } from 'react-redux'

import { photoRatingSettingNextAction } from 'actions/photoRating/photoRatingSettingsNextAction'
import { preparePromoRatingAction } from 'actions/rating/promoNextAction'
import { DefaultLoader } from 'components/presentational/AnimatedWatch/AnimatedWatch'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

import { useCacheVotedPhotos } from './hooks/useCacheVotedPhotos'
import { RatingNext } from './RatingNext'

export const RatingNextSettingsLayer = () => {
  useCacheVotedPhotos()

  const dispatch = useDispatch()
  const { settingsLoaded, vip } = useShallowEqualSelector(
    ({ photoRatingSettings: { settingsLoaded }, userReducer: { vip } }) => ({
      settingsLoaded,
      vip,
    })
  )

  useEffect(() => {
    dispatch(photoRatingSettingNextAction())
    dispatch(preparePromoRatingAction())
  }, [dispatch, vip])

  if (settingsLoaded) {
    return <RatingNext />
  }

  return <DefaultLoader />
}
